import React, { useCallback, useState } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';
import AuthForm from 'components/auth/tools/AuthForm';
import NiceModal from 'components/modals/NiceModal';
import { SIGNUP_MODE } from 'constants/auth';
import useModalState from 'hooks/useModalState';
import { useMappedState } from 'redux-react-hook';
import styled from 'styled-components';
import { isBlank } from 'utils/storeUtils';

import empty_like from '../../../assets/empty_like.svg';
import filled_like from '../../../assets/filled_like.svg';
import { useAddLikeMutation, useGetMyLikedGamesIdsQuery, useRemoveLikeMutation } from '../../../services/api/gamesApi';

export default function GameLike(props) {
  const { gameId, size = 28 } = props;

  const [liking, setLiking] = useState(false);

  const { data: myLikedGamesIds, refetch: refetchMyLikes } = useGetMyLikedGamesIdsQuery();
  const [addLike] = useAddLikeMutation();
  const [removeLike] = useRemoveLikeMutation();

  const [isAuthModalOpen, openAuthModal, closeAuthModal] = useModalState();
  const [confVisible, setConfVisible] = useState(false);

  const { currentUser } = useMappedState(
    useCallback(state => {
      const currentUser = state.users.usersMap.get(state.users.currentUserId);
      return {
        currentUser: currentUser,
      };
    }, [])
  );

  const isLikedByMe = (myLikedGamesIds || []).indexOf(gameId) > -1;
  const imgSrc = isLikedByMe ? filled_like : empty_like;

  const handleLike = async () => {
    if (isBlank(currentUser)) {
      openAuthModal();
      return;
    }
    setLiking(true);
    if (!isLikedByMe) {
      await addLike(gameId);
      setConfVisible(true);
      setTimeout(() => {
        setConfVisible(false);
      }, 3 * 1000);
    } else {
      await removeLike(gameId);
    }
    refetchMyLikes();
    setLiking(false);
  };

  return (
    <span>
      <Img
        src={imgSrc}
        alt={'like'}
        style={{ opacity: liking ? 0.5 : 1, height: size, width: size }}
        onClick={handleLike}
      />
      {confVisible && (
        <ConfettiExplosion mode="boom" particleCount={50} colors={['#ff577f', '#ff884b']} />
      )}
      {isAuthModalOpen && (
        <NiceModal onClose={closeAuthModal}>
          <ModalInnerPlaceholder>
            <AuthForm mode={SIGNUP_MODE} onClose={closeAuthModal} />
          </ModalInnerPlaceholder>
        </NiceModal>
      )}
    </span>
  );
}

const Img = styled.img`
  cursor: pointer;
  min-width: 28px;
  min-height: 28px;
`;

const ModalInnerPlaceholder = styled.div`
  width: 380px;
  padding: 24px;
  box-sizing: border-box;
  @media (max-width: 400px) {
    width: 100%;
  }
`;